export const ADD_PAGE_TO_VIEWED = 'ADD_PAGE_TO_VIEWED';
export const LOAD_PAGE_TO_VIEWED = ' LOAD_PAGE_TO_VIEWED';
export const RESET_PAGE_TO_VIEWED = 'RESET_PAGE_TO_VIEWED';




// WEBPACK FOOTER //
// ./src/redux/action-types/ui/addPageToViewed.js